import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";

import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
);
const SubjectWisePerformnace = (props) => {
    const items = useSelector((state) => state.userDetailsData.LoginDetails);
    const [SubjectsData, SetSubjectsData] = useState([]);
    const [GraphImages, SetGraphImages] = useState();
    const colors = ["#6a4c93", "#6e8b3d", "#e86e00"];
    const chartRef = useRef();
    const NationalPerformance = async () => {
        await axios
            .get(
                process.env.REACT_APP_API_BASE_URL +
                `/InstitutionAdmin/GetNationalPerformancebyGrade?ContestCreationId=${props.CCAT?.contestCreationId}&AssessmentType=${props.CCAT?.assessmentType}&InstituteId=${props.SIND}&Grade=${props.Grade}`,
                { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
            )
            .then((res) => {

                if (res.data[0].subjectName) {
                    console.log("National", res.data);
                    const FormatData = res.data.map((Sub) => ({
                        Label: Sub.subjectName,
                        Value: Sub.percentage,
                    }))
                    SetSubjectsData(FormatData);
                    setTimeout(() => {
                        getChartImage();
                    }, 2000);
                }
                //  else {
                //     SetNSData(process.env.REACT_APP_NODATAFOUND_Participated);
                // }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const StatePerformance = async () => {
        await axios
            .get(
                process.env.REACT_APP_API_BASE_URL +
                `/InstitutionAdmin/GetStatePerformancebyGrade?ContestCreationId=${props.CCAT?.contestCreationId}&AssessmentType=${props.CCAT?.assessmentType}&InstituteId=${props.SIND}&RegionId=${props.SIND === 1 ? props.RSIDs : 0}&Grade=${props.Grade}`
                ,
                { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
            )
            .then((res) => {
                console.log("STate", res.data);
                if (res.data[0].state) {
                    const FormatData = res.data.map((Sub) => ({
                        Label: Sub.subjectName,
                        Value: Sub.percentage,
                    }))
                    SetSubjectsData(FormatData);
                    SetSubjectsData(FormatData);
                    setTimeout(() => {
                        getChartImage();
                    }, 2000);
                }
                // else {
                //     SetDistrictWisedata(process.env.REACT_APP_NODATAFOUND_Participated);
                // }
                // SetLoad((prev) => !prev);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const GetScoietyPercentage = async () => {
        await axios
            .get(
                process.env.REACT_APP_API_BASE_URL +
                `/InstitutionAdmin/GetSocietyPerformancebyGrade?ContestCreationId=${props.CCAT?.contestCreationId}&AssessmentType=${props.CCAT?.assessmentType}&InstituteId=${props.SIND}&SocietyId=${props.SOID}&Grade=${props.Grade}`,
                { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
            )
            .then((res) => {
                console.log("SOID", res.data);
                if (res.data[0].subjectName) {
                    const FormatData = res.data.map((Sub) => ({
                        Label: Sub.subjectName,
                        Value: Sub.percentage,
                    }))
                    SetSubjectsData(FormatData);
                    SetSubjectsData(FormatData);
                    setTimeout(() => {
                        getChartImage();
                    }, 2000);
                }
                // else {
                //     SetDistrictWisedata(process.env.REACT_APP_NODATAFOUND_Participated);
                //     SetLoad((prev) => !prev);
                // }
            })
            .catch((err) => {
                console.log(err);
            });
    };
    useEffect(() => {
        props.GraphImg("");
        if (props.SIND == 1 || props.SIND == 3) {
            NationalPerformance();
        } else {
            if (props.SOID) {
                GetScoietyPercentage();
            } else {
                StatePerformance();
            }
        }
    }, [props.CCAT, props.SelectINID, props.RSIDs, props.SOID, props.Grade]);

    const getChartData = (subject) => ({
        labels: SubjectsData?.map((item) => item.Label) || [],
        datasets: [
            {
                label: "Performance %",
                data: SubjectsData?.map((item) => item.Value) || [],
                backgroundColor: colors,
                borderRadius: 5,
                barThickness: 80,
            },
        ],
    });
    const options = {
        // aspectRatio: 3,
        responsive: true,
        // maintainAspectRatio: false,

        plugins: {
            legend: {
                display: false,
            },

            // tooltip: {
            //   callbacks: {
            //     label: function (context) {
            //       return `${context.parsed.y}%`;
            //     },
            //   },
            // },

            datalabels: {
                anchor: "end",
                align: "end",
                formatter: (value) => value + "%",
                //  color: () => "#FFFFFF",
                font: {
                    weight: "bold",
                    size: 20,
                },


            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: "Subjects",
                    font: {
                        size: 20,
                    },
                },

                grid: {
                    display: false,
                },
                ticks: {
                    callback: function (value) {
                        const label = this.getLabelForValue(value);
                        return label.split("-");
                    },
                    font: {
                        size: 20,
                    },
                }
            },

            y: {
                beginAtZero: true,
                max: 100,
                ticks: {

                    font: {
                        size: 20,
                    },
                },
                title: {
                    display: true,
                    text: "Average %",
                    font: {
                        size: 20,
                    },
                },
            },
        },
    };
    const getChartImage = (subject) => {
        const chart = chartRef.current;

        if (chart) {
            SetGraphImages(chart.canvas.toDataURL("image/png"));
            props.GraphImg(chart.canvas.toDataURL("image/png"));
        }
    };
    return (
        <>  <Bar style={{
            display: "none",
            // marginBottom: "10px",
            // width: "100%",
            // height: "50px",
        }}
            data={getChartData()} ref={chartRef}
            options={options} plugins={[ChartDataLabels]}
        /></>
    )
}
export default SubjectWisePerformnace;